module.exports = __webpack_public_path__ + "static/clientes-1-a6a20656087898b28413c9548f2915df.png";